import { createStore } from 'vuex'
import Login from './login'
import Set from './set'
import Project from './project'
import Subject from './subject'
import SubjectSet from './subjectSet'
import Vocabulary from './vocabulary'
import Admin from './admin'
import StudentViewingHistory from './viewHistory'
import StudentTest from './studentTest'
import TestCorrectedAnswer from './testCorrectedAnswer'
import VIP from './vip'
import StudentOverview from './studentOverview'
import Recording from './recording'
import StudentPlan from './studentPlan'
import Grade from './grade'
import Elsa from './elsa'
import DeepSeek from './deepseek'
import YoudaoAI from './youdaoai'
import TyperAssignment from './typerAssignment'
import TyperAssignmentResult from './typerAssignmentResult'
import TyperSample from './typerSample'
import VocStudentClozeTest from './vocStudentClozeTest'
import VocClozeAssignment from './vocClozeAssignment'
import VocClozeAssignmentResult from './vocClozeAssignmentResult'

export default createStore({
  modules: {
    Login,
    Set,
    Project,
    Subject,
    SubjectSet,
    Vocabulary,
    Admin,
    StudentViewingHistory,
    StudentTest,
    TestCorrectedAnswer,
    VIP,
    StudentOverview,
    Recording,
    StudentPlan,
    Grade,
    Elsa,
    DeepSeek,
    YoudaoAI,
    TyperAssignment,
    TyperAssignmentResult,
    TyperSample,
    VocStudentClozeTest,
    VocClozeAssignment,
    VocClozeAssignmentResult
  }
})
